export default "__VITE_ASSET__DEN3d5Lp__"